import React, { useMemo, useState } from 'react'

import { getIntegrationDetails } from '@demo-system/commons/utilities/integrations'

import { useProject } from 'hooks'
import { useDsnApiV2 } from 'services/axios'

import { SurfacesEditor } from './SurfacesEditor'

import './DecisioningSurfaces.scss'

export default function DecisioningSurfaces() {
  const { project, canEdit, updateProjectPart } = useProject()

  const profileViewer = project?.profileViewer || {}
  const [entries, setEntries] = useState(profileViewer.surfaces?.entries || [])

  const { orgId, sandboxName } = getIntegrationDetails(project?.integrations)
  const channelConfigurationsRequest = useMemo(
    () => ({
      url: '/journey/channel-configurations',
      method: 'GET',
      params: { orgId, sandboxName, platform: 'web', channel: 'code' },
    }),
    [orgId, sandboxName]
  )
  const [{ data: rawSurfaceOptions }] = useDsnApiV2(channelConfigurationsRequest)
  const surfaceOptions = useMemo(
    () => (rawSurfaceOptions ? [...new Map(rawSurfaceOptions.map((option) => [option.surface, option])).values()] : undefined),
    [rawSurfaceOptions]
  )

  const onEntriesChange = (newEntries) => {
    setEntries(newEntries)
    updateProjectPart('profileViewer', { ...profileViewer, surfaces: { ...profileViewer.surfaces, entries: newEntries } })
  }

  return (
    <div className='DecisioningSurfaces'>
      <div className='DecisioningSurfaces__contentArea'>
        <SurfacesEditor
          surfaces={entries}
          disabled={!canEdit}
          onChange={onEntriesChange}
          surfaceOptions={surfaceOptions}
        />
      </div>
    </div>
  )
}
